// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__40VH3","question":"Accordion_question__KeXe3","serialNumber":"Accordion_serialNumber__IrSHS","answer":"Accordion_answer__G1q3P"};